import type { Block, ParagraphData } from "../../../../models/ManualAuthoring";
import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import StructuredInlineTextEditor from "../editor/StructuredInlineTextEditor";
import "./subStep.css";

export default function SubStepEdit({
  block,
  subStepLabel = "a.",
  onDone,
}: {
  block: Block;
  subStepLabel?: string;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-substep pdf-substep--editing">
      <span className="pdf-substep__num">{subStepLabel}</span>

      <div className="pdf-substep__text">
        <StructuredInlineTextEditor
          textParts={data.textParts || []}
          onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
          onDone={onDone}
        />
      </div>
    </div>
  );
}
